import React, { Component } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { s360ConfigService } from "../../Services/S360Config";
import dayjs from "dayjs";
import {
  dateByAdding,
  isNullOrUndefined,
  returnDates,
} from "../../HWLibrary/HWUtils";
import { createTheme, ThemeProvider } from "@mui/material";

class MessageA5 extends Component {
  constructor(props) {
    super(props);
    let dateInputs = this.parseDateInputs(props);
    this.state = {
      dateInputs: dateInputs,
      selectedDate: dateInputs.minDate || new Date(),
      value: "",
      actionDone: false,
      maxDate: new Date(dateInputs.maxDate),
      minDate: new Date(dateInputs.minDate),
    };
  }

  componentDidMount() {
    window.addEventListener(
      "message",
      (messageEvent) => {
        console.log(messageEvent, "A5MESSAGEEVENT");

        try {
          switch (messageEvent.data.event) {
            case "calendly.event_scheduled":
              this.onSubmitCalendly();
              break;
            case "calendly.date_and_time_selected":
              this.setState({ dateandTimeSelected: messageEvent.data });
              break;

            default:
              break;
          }
        } catch (error) {
          console.log("Invalid Message Data: ");
        }
      },
      false
    );
  }

  onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
    e.target.style.borderColor = isNullOrUndefined(
        designDetails.buttonHighlightBorderColor
      )
        ? isNullOrUndefined(designDetails.buttonBorderColor)
          ? "#0092ed"
          : designDetails.buttonBorderColor
        : designDetails.buttonHighlightBorderColor;
  };

  onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
    e.target.style.borderColor = isNullOrUndefined(designDetails.buttonBorderColor)
      ? "#0092ed"
      : designDetails.buttonBorderColor;
  };

  parseDateInputs = (props) => {
    let dateInputs = {};
    if (props.entry.text_data) {
      console.log(props.entry, "entry check");
      let data = props.entry.text_data;
      if (
        !isNullOrUndefined(data.from_day) &&
        !isNullOrUndefined(data.to_day)
      ) {
        {
          dateInputs.minDate = new Date(dateByAdding(data.from_day));
        }
        {
          dateInputs.maxDate = new Date(dateByAdding(parseInt(data.to_day)));
        }
      } else {
        if (data.from_date) {
          dateInputs.minDate = returnDates(data.from_date);
        }
        if (data.to_date) {
          dateInputs.maxDate = returnDates(data.to_date);
        }

        let date = dateInputs.minDate;
        let datearray = date.split("/");
        let newdate = datearray[1] + "/" + datearray[0] + "/" + datearray[2];
        dateInputs.minDate = newdate;

        let date1 = dateInputs.maxDate;
        let datearray1 = date1.split("/");
        let newdate1 =
          datearray1[1] + "/" + datearray1[0] + "/" + datearray1[2];
        dateInputs.maxDate = newdate1;
      }
    }

    console.log(dateInputs, "dateInputs");
    return dateInputs;
  };

  messageBoxStyle = () => {
    return {
      background: s360ConfigService.config.designDetails.senderMessageColor,
      fontFamily: s360ConfigService.config.designDetails.SenderMessageFont,
      fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize,
      color: s360ConfigService.config.designDetails.senderMessageFontColor,
    };
  };

  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "20px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
    };
    return styleData;
    // return {
    //   background: s360ConfigService.config.designDetails.recieverMessageColor,
    //    fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //    fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //    color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //    marginLeft: '15px'
    //   }
  };

  onDateSelect = (selectedDate) => {
    this.setState({ selectedDate: selectedDate, value: selectedDate });
    if (this.state.actionDone) {
      this.setState({ selectedDate: selectedDate, value: false });
    } else {
      this.setState({ selectedDate: selectedDate, value: selectedDate });
    }

    //  this.props.actions.sendMessage(dayjs(selectedDate).format("DD/MM/YY"));
  };

  onSubmit = (e) => {
    console.log(
      dayjs(this.state.selectedDate).format("DD/MM/YY"),
      "data in a5"
    );
    this.onMouseLeaveButton(e);
    this.setState({ value: false, actionDone: true });
    this.props.actions.sendMessage(
      dayjs(this.state.selectedDate).format("DD/MM/YYYY")
    );
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // this.onMouseLeave({ "target": n[i]});
    }
  };
  onSubmitCalendly = (e) => {
    this.setState({ value: false, actionDone: true });
    this.props.actions.sendMessage("Scheduled");
  };
  materialTheme = createTheme({
    palette: {
      primary: {
        main: "rgb(242, 101, 34)",
        light: "#f6b243",
        dark: "#f6b243",
      },
      secondary: {
        main: "#f6b243",
      },
    },
    components: {
      MuiPickersDay: {
        styleOverrides: {
          root: {
            color: isNullOrUndefined(this.props.config.calenderBackgroundColor)
              ? "rgb(242, 101, 34)"
              : this.props.config.calenderBackgroundColor,
            "&.Mui-selected": {
              backgroundColor: isNullOrUndefined(
                this.props.config.calenderBackgroundColor
              )
                ? "rgb(242, 101, 34)"
                : this.props.config.calenderBackgroundColor,
            },
            "&.Mui-disabled": {
              color: "#c3c7c4",
            },
          },
        },
      },
    },
  });

  render() {
    let displayText = this.props.entry.text;
    let isCalendly = this.props.entry.text_data.calendly;
    let calendlyUrl = this.props.entry.text_data.url;
    const styles = {
      height: "100%",
    };
    const pageSettings = {
      backgroundColor: "ffffff",
      hideEventTypeDetails: false,
      hideLandingPageDetails: false,
      primaryColor: "00a2ff",
      textColor: "4d5055",
    };
    function disableSundays(date) {
      if (new Date(date).getDay() == 0) return true;
    }
    var lastdayofMonth = function (y, m) {
      console.log(new Date(y, m + 1, 0), "here in A%");
      return new Date(y, m + 1, 0);
    };
    console.log(this.props.entry, "isCalendly");

    return (
      <>
        {
          <div className="s360-message-cotainer-received">
            <div
              className="s360-message-box-custom-a14-received"
              style={this.messageBoxStyle()}
            >
              {displayText && <div>{displayText}</div>}
              <div style={{ padding: "10px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <ThemeProvider theme={this.materialTheme}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={dayjs(this.state.selectedDate)}
                      onChange={this.onDateSelect}
                      minDate={this.state.dateInputs.minDate ? dayjs(this.state.dateInputs.minDate) : undefined}
                      maxDate={this.state.dateInputs.maxDate ? dayjs(this.state.dateInputs.maxDate) : undefined}
                      shouldDisableDate={
                        !isNullOrUndefined(this.props.config.enableWeekend)
                          ? undefined
                          : (date) => dayjs(date).day() === 0
                      }
                      slotProps={{ textField: { variant: "standard", size: "small" } }}
                    />
                  </ThemeProvider>
                </LocalizationProvider>
              </div>
            </div>
            {this.props.isLastEntry && this.props.sentTimestamp && (
              <div
                className={this.messageTimeClassName()}
                style={this.messageTimeStyle()}
              >
                {dayjs.unix(this.props.sentTimestamp).format("DD MMM h:mm a")}
              </div>
            )}
            <div className="s360-message-cotainer-received">
              <button
                disabled={this.props.disabled}
                className="s360-message-box-custom-a15-received"
                onClick={this.onSubmit}
                onMouseEnter={this.onMouseEnterButton}
                onMouseLeave={this.onMouseLeaveButton}
                style={this.messageBoxSubmitStyle()}
              >
                {this.props.entry.data
                  ? JSON.parse(this.props.entry.data).buttonText
                  : "Submit"}
              </button>
            </div>
          </div>
        }
      </>
    );
  }
}

export default MessageA5;
